import { render } from "./approved-message.vue?vue&type=template&id=6367fbc0"
import script from "./approved-message.vue?vue&type=script&lang=js"
export * from "./approved-message.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__